import {Directive} from '@angular/core';

/* To override a default toggle icon */
@Directive({selector: '[ngxMaterialTimepickerToggleIcon]'})

export class NgxMaterialTimepickerToggleIconDirective {
}
